export default {
  'profile.verified': '已验证',
  'profile.unverified': '未验证',
  'profile.refresh': '刷新',
  'profile.name': '姓名',
  'profile.getCode': '获取验证码',
  'profile.codeTip': '请输入验证码',
  'profile.verifyCode': '验证码',
  'profile.phoneChange': '手机号码修改',
  'profile.checkPhone': '验证当前手机',
  'profile.bindNewPhone': '绑定新手机',
  'profile.nuxt': '下一步',
  'profile.changeSuccess': '修改成功！',
  'profile.firstNameTip': '请输入名字',
  'profile.lastNameTip': '请输入姓氏',
  'profile.emailChange': '邮件修改',
  'profile.checkEmail': '验证当前邮箱',
  'profile.bindNewEmail': '绑定新邮箱',
  'profile.bindEmailTip': '请输入新邮箱',
  'app.profile': '个人中心',
  'app.profile.account': '账号信息',
  'app.profile.account.save': '保存',
  'app.profile.account.account': '登录帐号',
  'app.profile.account.password': '登录密码',
  'app.profile.account.password.update': '最后一次密码更新时间',
  'app.profile.account.password.reset': '重置密码',
  'app.profile.account.name.first': '名字',
  'app.profile.account.name.last': '姓氏',
  'app.profile.account.name.phone': '手机号码',
  'app.profile.account.name.phone.tip':
    '我们可能会使用此电话号码，向您传送验证码、帐单和业务预警等资讯',
  'app.profile.account.name.url': '回调地址',
  'app.profile.account.name.urlTip':
    '必须以http:// 或者 https://开头，不支持自定义端口，不支持IP为10.0.0.0/8，172.16.0.0/12，192.168.0.0/16 私有网段。',
  'app.profile.account.name.verification': '校验',
  'app.profile.account.name.verification.tip[1]': '成功',
  'app.profile.account.name.verification.tip[2]': '失败',
  'app.profile.developer': '开发者信息',
  'app.profile.developer.remark': '仅限于 API 调用时使用',
  'app.profile.developer.label[1]': '开发者标识（DevKey）',
  'app.profile.developer.label[2]': 'API DevSecret',
  'app.profile.developer.copy': '查看并复制',
  'app.profile.developer.reset': '重置',
  'app.profile.developer.reset.tip': '提示', //新加的
  'app.profile.developer.reset.tip.content':
    'Dev Secret 变更将影响 API 推送，需要调用方更改调用代码', //新加的
  'app.profile.developer.reset.tip.sure': '确认重置', //新加的
  'app.profile.developer.reset.tip.cancel': '再考虑下', //新加的
  'app.profile.developer.copy.success': '复制成功',
  'app.profile.developer.reset.success': '重置成功',
  'app.profile.single': '单点登录',
  'app.profile.single.tip[1]': '提高安全性，降低帐户被盗的风险',
  'app.profile.single.tip[2]': '避免企业员工因使用不同业务系统而频繁建立帐号',
  'app.profile.single.tip[3]': '使用企业内部员工帐号系统，简化身份验证',
  'app.profile.single.enable': '联系商务',
  'app.profile.single.title': '业务请求',
  'app.profile.single.subject': '主题',
  'app.profile.single.subject.value': '为我的账户启用单点登录',
  'app.profile.single.content': '您好，我想启用单点登录。请向我提供帮助。谢谢。',
  'app.profile.single.subject.validator': '请输入主题',
  'app.profile.single.subject.doc': '为我的帐户启用单点登入',
  'app.profile.single.message': '内容',
  'app.profile.single.message.validator': '请输入内容',
  'app.profile.single.submit': '提交',
  'app.profile.single.submit.success': '提交成功，待管理人员邮件回复',
  'app.profile.account.deletion': '删除我的帐户',
  'app.profile.account.deletion.warn':
    '删除帐户操作后，EngageLab 将永久删除您的帐号，以及帐号相关所有用户信息、业务资讯和订单信息等资料。一旦删除，您将无法恢复帐户和资料',
  'app.profile.account.deletion.action': '删除我的帐户',
  'app.profile.delete.title': '删除帐号',
  'app.profile.delete.content':
    '警告！删除帐号操作为不可逆，将永久删除该帐号内的用户、业务、余额、帐单、订单和权益等资料和信息，同时停止所有相关服务。 ',
  'app.profile.delete.content2':
    '或许您可以通过「修改账户邮箱地址」或「为组织成员授予角色权限」的方式来达成目的，建议您在非必要的情况下尽量保留帐户的使用。',
  'app.profile.delete.warn': '无法删除帐户，该帐户须无待补缴的帐单，否则将无法删除！ ',
  'app.profile.delete.cancel': '取消',
  'app.profile.delete.next': '下一步',
  'app.profile.delete.delete': '删除',
  'app.profile.delete.confirm': '确认删除帐号',
  'app.profile.delete.confirm.content':
    '您提交的删除账号申请生效前，我们将进行下列验证事宜，以确保您的帐号安全。请检查电子邮件中的验证码信息',
  'app.profile.delete.confirm.send': '发送验证码',
  'app.profile.delete.confirm.send.resend': '重新发送验证码',
  'app.profile.delete.confirm.resend': '重新发送',
  'app.profile.delete.confirm.rule': '请输入正确的验证码',
  'app.profile.delete.confirm.code.title': '邮箱验证码',
  'app.profile.delete.confirm.code.desc':
    '为验证身份，确保帐户安全，请提供您邮箱 currentAccount.email 收到的验证码',
  'app.profile.delete.confirm.reason.title': '删除原因',
  'app.profile.delete.confirm.reason.desc': '这些信息能帮助我们改进产品',
  'app.profile.delete.confirm.reason.placeholder': '选择原因',
  'app.profile.delete.confirm.reason.select1': '删除测试账户',
  'app.profile.delete.confirm.reason.select2': '更换使用其他账户',
  'app.profile.delete.confirm.reason.select3': '不再有兴趣使用 EngageLab 服务',
  'app.profile.delete.confirm.reason.select4': '其他',
  'app.profile.reset.title': '重置密码',
  'app.profile.reset.password.old': '旧密码',
  'app.profile.reset.password.old.placeholder': '请输入旧密码',
  'app.profile.reset.password.new': '新密码',
  'app.profile.reset.password.new.placeholder': '请输入新密码',
  'app.profile.reset.password.confirm': '确认密码',
  'app.profile.reset.password.confirm.placeholder': '请确认新密码',
  'app.profile.reset.cancel': '取消',
  'app.profile.reset.confirm': '确认',
  'app.profile.rule.blank': '内容不得为空',
  'app.profile.reset.new.rule[0]': '包含至少 8 个字符',
  'app.profile.reset.new.rule[1]': '不符合包含小写字母 (a-z) 和大写字母 (A-Z) 的条件',
  'app.profile.reset.new.rule[2]': '符合至少包含一个数字 (0-9) 或一个符号的条件',
  'app.profile.reset.confrim.rule[0]': '两次输入密码不一致',
  'app.profile.reset.old.rule[0]': '密码输入不正确',
  'app.profile.reset.success': '密码修改成功',
  'app.profile.aws.title': '亚马逊订单',
  'app.profile.aws.subtitle':
    '您的 EngageLab 账户已与亚马逊账户绑定，您可以在此将亚马逊的订单与相应的 EngageLab 服务进行关联绑定，从而获得 EngageLab VIP 权益。',
  'app.profile.aws.account': '亚马逊账户 ID：',
  'app.profile.aws.btn': '管理订单',
  'app.profile.human.code.loadingTip': '请稍候…',
  'app.profile.human.code.placeholder': '请输入验证码',
  'app.profile.human.check.tip': '请先完成人机校验。',
  'app.profile.human.check.error': '人机校验失败，请重试。',
  'app.profile.sso.title': 'SSO 配置服务',
  // SSO Empty
  'app.profile.sso.empty.title': '您尚未配置任何 SSO',
  'app.profile.sso.empty.description':
    '配置 SSO 后，配置组织下用户、成员、和业务合作伙伴能够安全地访问他们完成最佳工作所需的一切，以及直观的登录体验。',
  'app.profile.sso.empty.configure': '配置 SSO',
  'app.profile.sso.empty.title2': '暂无 SSO 权益',
  'app.profile.sso.empty.description2':
    '您的组织暂未开通 SSO 权益，请联系商务开通权益后再进行配置。',
  'app.profile.sso.empty.contact': '立即联系',
  'app.profile.sso.empty.contact.content': '我想创建 SSO',
  // SSO List
  'app.profile.sso.list.configure': '配置 SSO',
  'app.profile.sso.list.authorizedOrg': '已授权组织',
  'app.profile.sso.list.benefitStatus': '权益状态',
  'app.profile.sso.list.authorizedOrgLong':
    '已授权组织已授权组织已授权组织已授权组织已授权组织已授权组织已授权组织',
  'app.profile.sso.list.edit': '编辑',
  'app.profile.sso.list.authorize': '授权',
  'app.profile.sso.list.delete': '删除',
  'app.profile.sso.list.deleteConfirm.title': '确认删除 SSO 服务 {name}？',
  'app.profile.sso.list.deleteConfirm.content':
    '删除 SSO 服务后，该服务授权的组织将不再支持 SSO 登录，且登录链接将失效，并收到一封停止使用 SSO 登录的邮件。',
  'app.profile.sso.list.deleteSuccess': '删除成功',
  'app.profile.sso.list.confirm.modify.title': '确定修改 SSO 服务授权？',
  'app.profile.sso.list.confirm.modify.content.add':
    '新增授权的组织，所有组织成员将收到一封提醒邮件，提供了本 SSO 服务的登录链接，要求他们使用本 SSO 服务进行登录。',
  'app.profile.sso.list.confirm.modify.content.remove':
    '取消授权的组织，所有组织成员将收到一封提醒邮件，告知他们无法再使用本 SSO 服务登录，并提供了组织支持的其他登录方式。',
  // SSO Option
  'app.profile.sso.option.step1': 'IdP 配置',
  'app.profile.sso.option.step2': '数据返回',
  'app.profile.sso.option.step3': '授权组织',
  'app.profile.sso.option.step4': '验证',
  'app.profile.sso.option.continue': '继续',
  'app.profile.sso.option.prev': '上一步',
  'app.profile.sso.option.back': '返回',
  'app.profile.sso.option.submit': '完成',
  'app.profile.sso.option.save': '保存并验证',
  // SSO Step 1
  'app.profile.sso.step1.title': '在 IdP 中配置 Engagelab',
  'app.profile.sso.step1.description':
    '单点登录单点登录（SSO），您首先需要将 Engagelab 添加为身份提供商（IdP）中的应用程序。请联系您的组织的 IdP 管理员以在您的帐户下添加属配置 IdP 的应用程序设',
  'app.profile.sso.step1.serviceType': 'SSO 服务类型',
  'app.profile.sso.step1.guideText': '可使用使用以下令牌唯一您组织的 IdP 管理员进行协作：',
  'app.profile.sso.step1.copy': '复制',
  'app.profile.sso.step1.confirmTip': '该确认 Engagelab 应用程序的信息已在您的 IdP 中更新',
  'app.profile.sso.step1.infoText': `I am setting up SSO for Engagelab, and I need assistance setting up Engagelab as an application in our identity provider.

Here is the information that Engagelab provides for setting up the application:

Entity ID:643e77b90116033eef7e325b001
ACS URL: https://www.engagelab.com/accounts/signin/callback?connection=643e77b90116033eef7e325b001
Login URL：https://www.engagelab.com/accounts/signin-sso
Logout URL：https://www.engagelab.com/api/console/account/login/out

Once the Engagelab application is set up in our IdP, please send me the following information from the IdP to complete SSO setup in Engagelab:

X.509 certificate:`,
  // SSO Step 2
  'app.profile.sso.step2.title': '输入 IdP 返回的数据',
  'app.profile.sso.step2.description':
    '现在您已经在身份提供商中设置了 Engagelab 应用程序并拥有必要的信息，请将 IdP 应用程序的以下信息在此输入。',
  'app.profile.sso.step2.serviceName': 'SSO 服务的名称',
  'app.profile.sso.step2.serviceNamePlaceholder':
    '请输入一个描述 SSO 服务的名称，便于服务列表进行区分',
  'app.profile.sso.step2.certificate': 'x509 Certificate',
  'app.profile.sso.step2.certificatePlaceholder': '请将 base64 证书的内容复制在此处',
  'app.profile.sso.step2.loginUrl': 'IdP Login URL',
  'app.profile.sso.step2.loginUrlPlaceholder': '请输入身份提供商的登录 URL',
  'app.profile.sso.step2.logoutUrl': 'IdP Logout URL',
  'app.profile.sso.step2.logoutUrlPlaceholder': '请输入身份提供商的注销 URL',
  // SSO Step 3
  'app.profile.sso.step3.title': '将 IdP 授权给组织',
  'app.profile.sso.step3.description':
    '请将该 SSO 服务授权给您创建的组织，组织的成员可以使用所配置的身份提供商 （IdP）登录 Engagelab。',
  'app.profile.sso.step3.selectOrg': '选择组织',
  'app.profile.sso.step3.contactBusiness': '联系商务',
  'app.profile.sso.step3.saveConfirm.title':
    '为组织配置 SSO 服务后，组织成员必须使用 SSO 登录才能访问该组织',
  'app.profile.sso.step3.saveConfirm.content':
    '保存后，所有组织成员将被退出登录，并收到一封要求使用 SSO 登录的邮件',
  'app.profile.sso.step3.canAuthorize': '可授权',
  'app.profile.sso.step3.numLimit.title': '受限',
  'app.profile.sso.step3.numLimit.tip': 'SSO协议数量超限',
  'app.profile.sso.step3.numLimit.text': 'SSO协议数量超限，不可用',
  'app.profile.sso.step3.noBenefit.title': '无权益',
  'app.profile.sso.step3.noBenefit.text': '当前组织无权益，不可用',
  'app.profile.sso.step3.column.orgId': '组织ID',
  'app.profile.sso.step3.column.orgName': '组织名称',
  'app.profile.sso.step3.column.memberNum': '成员数量',
  'app.profile.sso.step3.column.authStatus': '授权状态',
  'app.profile.sso.step3.column.timeZone': '时区',
  'app.profile.sso.step3.column.createTime': '创建时间',
  // SSO Step 4
  'app.profile.sso.step4.title': '验证 SSO 服务',
  'app.profile.sso.step4.description':
    '现在您已完成 SSO 的所有配置，最后请确认用户可以使用 SSO 成功登录 Engagelab。',
  'app.profile.sso.step4.loginUrl': 'SSO 登录 URL',
  'app.profile.sso.step4.tip': '提示',
  'app.profile.sso.step4.tipContent':
    '通过该链接登录的账号，若在组织内没有任何角色，将自动授予 Default 角色。您可以在成员加入后修改他的角色。',
  'app.profile.sso.step4.notice': '请注意',
  'app.profile.sso.step4.noticeContent':
    '通过该链接登录的账号，若在组织内没有任何角色，将自动授予 Default 角色。您可以在成员加入后修改他的角色。',
  'app.profile.sso.step4.needHelp': '仍需要帮助吗',
  'app.profile.sso.step4.helpContent': '无法登录成功?请参照文档说明进行检查。',
  'app.profile.sso.step4.viewDoc': '查看文档',
  // SSO Details
  'app.profile.sso.details.title': 'SSO 服务详情',
  'app.profile.sso.details.serviceDetails': 'SSO 服务详情',
  'app.profile.sso.details.name': '名称',
  'app.profile.sso.details.namePlaceholder': '请输入名称',
  'app.profile.sso.details.type': '类型',
  'app.profile.sso.details.typePlaceholder': '请输入类型',
  'app.profile.sso.details.loginLink': 'SSO 登录链接',
  'app.profile.sso.details.loginLinkPlaceholder': '请输入SSO 登录链接',
  'app.profile.sso.details.spConfig': 'SP 配置信息',
  'app.profile.sso.details.entityIdPlaceholder': '请输入Entity ID',
  'app.profile.sso.details.idpConfig': 'IDP 配置信息',
  'app.profile.sso.details.certificatePlaceholder': '请输入X.509证书',
  'app.profile.sso.details.loginUrlPlaceholder': '请输入Login URL',
  'app.profile.sso.details.logoutUrlPlaceholder': '请输入Logout URL',
  'app.profile.sso.details.urlPlaceholder': '请输入正确的URL',
  'app.profile.sso.details.certificateExpiry': '证书将于 {date} 到期',
  'app.profile.sso.details.cancel': '取消',
  'app.profile.sso.details.save': '保存',
  'app.profile.sso.details.edit': '编辑',
  // SSO OrgSelect
  'app.profile.sso.orgSelect.title': '授权组织',
  'app.profile.sso.orgSelect.availableOrg': '可选组织',
  'app.profile.sso.orgSelect.serviceExpired': '服务权益到期，不可用',
  'app.profile.sso.orgSelect.contactBusiness': '联系商务',
  'app.profile.sso.orgSelect.authorizedService': '已授权服务',
  'app.profile.sso.orgSelect.serviceNameLong':
    'SSO服务名称服务名称服务名称服务名称SSO服务名称服务名称服务名称服务名称SSO服务名称服务名称服务名称服务名称SSO服务名称服务名称服务名称服务名称',
  'app.profile.sso.orgSelect.selectedOrg': '已选组织',
  'app.profile.sso.orgSelect.noSelectedOrg': '暂无已选组织，请从左边选择组织',
  'app.profile.sso.orgSelect.noAvailable': '暂无可选组织',
  'app.profile.sso.orgSelect.authorized': '已授权',
  'app.profile.sso.orgSelect.cancel': '取消',
  'app.profile.sso.orgSelect.save': '保存',
  'app.profile.sso.orgSelect.canAuthorize': '可授权',
  'app.profile.sso.orgSelect.otherAuthorize': '其他授权',
  'app.profile.sso.orgSelect.noBenefit': '无权益',
  'app.profile.sso.orgSelect.saveSuccess': '保存成功',
  'app.profile.sso.list.ssoServiceName': 'SSO服务名称',
  'app.profile.sso.list.ssoType': '类型',
  'app.profile.sso.list.ssoLoginUrl': '登录链接',
  'app.profile.sso.list.authOrgList': '授权组织',
  'app.profile.sso.authorized.organizations': '已授权组织',
  'app.profile.sso.benefit.status': '权益状态',

  'app.sso.no.permission.title': '无此页面访问权限',
  'app.sso.no.permission.desc': '如需获取访问权限，请联系管理员',
  'app.sso.no.permission.logout': '退出登录',
};
